import { twMerge } from 'tailwind-merge';

import type { CheckboxProps } from './check-box';
import { Checkbox } from './check-box';

import { FormControl, FormItem, FormLabel, FormMessage } from '../form';
import type { FormLabelProps } from '../types';

export const FormCheckbox = ({
  ref,
  formItemClassName,
  label,
  labelClassName,
  innerClassName,
  hideMsg,
  ...props
}: CheckboxProps & FormLabelProps & { innerClassName?: string; hideMsg?: boolean }) => (
  <FormItem className={formItemClassName}>
    <div className={twMerge('flex flex-row items-center justify-start space-y-0 space-x-3', innerClassName)}>
      <FormControl>
        <Checkbox {...props} ref={ref} />
      </FormControl>

      {(label || props.value) && (
        <FormLabel className={twMerge('cursor-pointer', props.disabled && 'cursor-default', labelClassName)}>
          {label ?? props.value}
        </FormLabel>
      )}
    </div>
    {!hideMsg && <FormMessage />}
  </FormItem>
);
